import { Route, Routes } from "react-router-dom";
import { DesignPackageProductCardPage } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage";
import {
  designPackageAddProductPath,
  designPackageProductCardPath,
  designPackageProductSearchPath,
  relativeDesignCatalogPath,
} from "src/routes/routesDef";
import { DesignPackageConfigurator } from "./DesignPackageConfigurator";
import { DesignPackageConfiguratorProvider } from "./DesignPackageConfiguratorContext";
import { AddProductPage } from "./components/AddProductPage";
import { ProductSearchPage } from "./routes/search/ProductSearchPage";

export function DesignPackageConfiguratorLayout() {
  const rdc = relativeDesignCatalogPath;

  return (
    <DesignPackageConfiguratorProvider>
      <Routes>
        <Route path={rdc(designPackageProductCardPath)} element={<DesignPackageProductCardPage />} />
        <Route path={rdc(designPackageProductSearchPath)} element={<ProductSearchPage />} />
        <Route path={rdc(designPackageAddProductPath)} element={<AddProductPage />} />
        <Route index element={<DesignPackageConfigurator />} />
      </Routes>
    </DesignPackageConfiguratorProvider>
  );
}
